import type { AppDefinition } from '../types';

/**
 * WhatsApp Business — bring-your-own number.
 *
 * Not the same thing as Hero's own WhatsApp agent channel, which runs on
 * Hero's number and needs no install. This entry is for an Org that wants
 * customer messaging on a number it already owns.
 */
export const WHATSAPP_APP: AppDefinition = {
  id: 'whatsapp',
  nameKey: 'apps.whatsapp.name',
  descriptionKey: 'apps.whatsapp.description',
  logo: '/images/apps/whatsapp-logo.svg',
  categories: ['messaging'],
  status: 'soon',
  label: 'soon',
};
